import PropTypes from 'prop-types';
import React from 'react';

import StyledFilterTag from './filterTag.style';

const FilterTag = ({
  inverted = false,
  isInvertedArchiveFilter = false,
  className = '',
  children = '',
  border = false,
  light = false,
  small = false,
  ...props
}) => (
  <StyledFilterTag
    {...props}
    className={className}
    isInvertedArchiveFilter={isInvertedArchiveFilter}
    inverted={inverted}
    light={light}
    small={small}
    border={border}
  >
    <div className="filter-tag">
      <span className="filter-tag__title">{children}</span>
    </div>
  </StyledFilterTag>
);

FilterTag.propTypes = {
  children: PropTypes.string,
  className: PropTypes.string,
  inverted: PropTypes.bool,
  border: PropTypes.bool,
  isInvertedArchiveFilter: PropTypes.bool,
  light: PropTypes.bool,
  small: PropTypes.bool
};

export default FilterTag;
